import React from "react";
import { CalendarIcon, UserIcon } from "../../components/Primitives";
import { useAuthContext } from "../../providers/Auth/auth.provider";
import { AvailablePlatform, usePlatformContext } from "../../providers/Auth/platform.provider";
import config from "../../config/config";
import { getPomAgencyNavItems } from "../../pom-navigation-items";
import { AvailablePomRoutes } from "../../utils/constants";
import { isPomAgency } from "../user/user";
import { MenuListItem } from "./menu-list-item.component";
import { SidebarMenuItem } from "./sidebar-menu-item.component";

export const SidebarPomAgencyMenu: React.VFC = () => {
  const { internalUser } = useAuthContext();
  const { activePlatform } = usePlatformContext();

  const isPomPlatform = () => activePlatform === AvailablePlatform.Pom;
  const pomAgencyNavItems = isPomAgency(internalUser)
    ? getPomAgencyNavItems(internalUser?.group?.erpNumber, config.bcEditMasterDataUrl)
    : [];

  if (isPomPlatform() && isPomAgency(internalUser)) {
    return (
      <>
        {internalUser?.group?.isPomAgencyAnnouncer === true && (
          <MenuListItem
            path={AvailablePomRoutes.Reporting}
            MenuIcon={CalendarIcon}
            title={"pom.reportings.page_title"}
          />
        )}
        <MenuListItem path={AvailablePomRoutes.Agency} MenuIcon={UserIcon} title={"pom.agency.groups"} />
        {pomAgencyNavItems
          .filter((item) => item.visible && item.content)
          .map((item, index) => {
            return (
              <SidebarMenuItem
                key={`agency-${item.to}-${index}`}
                name="pom-agency"
                navItem={item}
                menuItem={item.label}
              />
            );
          })}
      </>
    );
  }
  return null;
};
